/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SettingsSlidersH3Icon20Solid = forwardRef('SettingsSlidersH3Icon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.206 6H3a1 1 0 0 1 0-2h8.206a2.503 2.503 0 0 1 4.588 0H17a1 1 0 1 1 0 2h-1.206a2.503 2.503 0 0 1-4.588 0Z" }),
        React.createElement("path", { d: "M3 9a1 1 0 1 0 0 2h1.21a2.498 2.498 0 0 0 4.58 0H17a1 1 0 1 0 0-2H8.79a2.498 2.498 0 0 0-4.58 0H3Z" }),
        React.createElement("path", { d: "M2 15a1 1 0 0 1 1-1h8.206a2.503 2.503 0 0 1 4.588 0H17a1 1 0 0 1 0 2h-1.206a2.503 2.503 0 0 1-4.588 0H3a1 1 0 0 1-1-1Z" })));
});
